// extracted by mini-css-extract-plugin
export var allResults = "ProductComparison-module--allResults--452d9";
export var aspectMenu = "ProductComparison-module--aspectMenu--7d5d1";
export var aspectName = "ProductComparison-module--aspectName--c200f";
export var aspectProd = "ProductComparison-module--aspectProd--907c9";
export var catAproducts = "ProductComparison-module--catAproducts--1d97a";
export var col = "ProductComparison-module--col--746bc";
export var columnWrap = "ProductComparison-module--columnWrap--72f5f";
export var columns = "ProductComparison-module--columns--1ad72";
export var comparativeAspect = "ProductComparison-module--comparativeAspect--7bee6";
export var comparativeResults = "ProductComparison-module--comparativeResults--fe7a9";
export var comparativeResultsB = "ProductComparison-module--comparativeResultsB--0ce79";
export var compareCol = "ProductComparison-module--compareCol--68bd2";
export var compareColA = "ProductComparison-module--compareColA--33c50";
export var compareResults = "ProductComparison-module--compareResults--db6d5";
export var comparison = "ProductComparison-module--comparison--ec35d";
export var comparisonFilter = "ProductComparison-module--comparisonFilter--e3f17";
export var ctaContainer = "ProductComparison-module--ctaContainer--904ad";
export var dots = "ProductComparison-module--dots--4524a";
export var learnOther = "ProductComparison-module--learnOther--ff57c";
export var learnSunlighten = "ProductComparison-module--learnSunlighten--6a314";
export var modelImage = "ProductComparison-module--modelImage--02a94";
export var nextArrowButtonA = "ProductComparison-module--nextArrowButtonA--55e32";
export var nextArrowButtonB = "ProductComparison-module--nextArrowButtonB--d0dee";
export var noAspectProd = "ProductComparison-module--noAspectProd--6fe72";
export var other = "ProductComparison-module--other--ad128";
export var otherProducts = "ProductComparison-module--otherProducts--b540f";
export var prevArrowButtonA = "ProductComparison-module--prevArrowButtonA--1cb2f";
export var prevArrowButtonB = "ProductComparison-module--prevArrowButtonB--9bfcd";
export var prodComparisonWrapper = "ProductComparison-module--prodComparisonWrapper--98cd8";
export var productImage = "ProductComparison-module--productImage--6c76b";
export var sunlighten = "ProductComparison-module--sunlighten--68512";